
export default function reducer(state ,action) {
  return action.type;
}